export interface GapItem {
  readonly type: 'gap';
  readonly value: string;
  readonly placeholder: string;
}

export interface TextItem {
  readonly type: 'text';
  readonly content: string;
}

export type GapOrTextItem = GapItem | TextItem;

export interface GapFillingParagraph {
  readonly items: readonly GapOrTextItem[];
}

export type GapFillingBehavior = 'drag-and-drop' | 'keyboard-type';

export const GapFillingBehaviorLabels = {
  'drag-and-drop': 'Drag and drop',
  'keyboard-type': 'Keyboard type'
} as const;

export interface GapFillingModel {
  readonly behavior: GapFillingBehavior;
  readonly paragraphs: readonly GapFillingParagraph[];
}

/******************************************************************************/
